import { UserContext } from "contexts/UserContext";
import { useContext } from "react";
import { useDictionary } from "@adamlip/okeoke.client";
import CustomInput from "components/CustomInput";
import { AppParamsContext } from "contexts/AppParamsContext";

export default function NonVipFields() {
  const { userData, handleChangeUserData } = useContext(UserContext);
  const { getValue } = useDictionary();
  const { appParams } = useContext(AppParamsContext);
  return (
    <>
      <CustomInput
        isDisabled
        name="email"
        label={getValue("app_v2_profile_email")}
        value={userData?.email || ""}
      />
      <CustomInput
        name="firstName"
        label={getValue("app_v2_profile_nickname")}
        value={userData?.firstName || ""}
        onChange={handleChangeUserData}
      />
      {appParams?.profile?.lastName && (
        <CustomInput
          name="lastName"
          label={getValue("app_v2_profile_lastName")}
          value={userData?.lastName || ""}
          onChange={handleChangeUserData}
        />
      )}
    </>
  );
}
